// src/components/ErrorBoundary.tsx
import { Component, ReactNode } from "react";
import { Link } from "react-router-dom";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex flex-col bg-background text-foreground">
          <main className="flex-grow flex items-center justify-center hero-gradient py-16">
            <div className="text-center max-w-2xl mx-auto px-4">
              <h1 className="text-5xl md:text-6xl font-serif font-bold text-nail-800 mb-6">
                Something Went Wrong
              </h1>
              <p className="text-lg text-muted-foreground mb-8">
                Oops! Something broke in our nail polish bottle. Let’s get you back to the beauty!
              </p>
              <Link
                to="/"
                className="inline-block bg-nail-500 hover:bg-nail-600 text-white text-lg py-3 px-8 rounded-md fancy-underline"
              >
                Back to Home
              </Link>
            </div>
          </main>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;